
<div> SMB onboarding page</div>
